<script setup>
import DataDetail from '@/components/member/DataDetail.vue'
</script>
<template>
  <DataDetail :id="$route.params.id" :type="$route.params.type" :ispage="true"/>
</template>
